import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { GetCustodyAnalyticsResponse } from 'api';

export const CUSTODY_ANALYTICS_QUERY_KEY = 'vestra/admin-custody-analytics';

export const useCustodyAnalyticsQuery = () =>
  useInfiniteQuery<GetCustodyAnalyticsResponse>({
    queryKey: [CUSTODY_ANALYTICS_QUERY_KEY],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await api.v1.getCustodyAnalyticsV1SrAdminCustodyAnalyticsGet({
        page: pageParam,
        page_size: 50,
      });
      return response.data;
    },
    getNextPageParam: ({ total, page, page_size }) =>
      Math.ceil(total / page_size) > page ? page + 1 : undefined,
    refetchInterval: 1000 * 60,
  });
